import { UserRegistrationForm } from "../../organisms/form/UserRegistrationForm";
import { MainTemplate } from "../../templates/MainTemplate";
import { useUserRegistration } from "./hook";

export const UserRegistrationPage: React.FC = () => {
  const {
    hasLoaded,
    canEditGroup,
    clients,
    groups,
    systems,
    handleCancel,
    handleRegisterUser,
  } = useUserRegistration();

  return (
    <MainTemplate title="新規アカウント登録">
      {hasLoaded && (
        <UserRegistrationForm
          canEditGroup={canEditGroup}
          systems={systems}
          clients={clients ?? []}
          groups={groups ?? []}
          onCancel={handleCancel}
          handleSubmit={handleRegisterUser}
        />
      )}
    </MainTemplate>
  );
};
